var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.79992 15.905L5.29992 12.405C4.90992 12.015 4.28992 12.015 3.89992 12.405C3.50992 12.795 3.50992 13.415 3.89992 13.805L8.08992 17.995C8.47992 18.385 9.10992 18.385 9.49992 17.995L20.0999 7.40502C20.4899 7.01502 20.4899 6.39502 20.0999 6.00502C19.7099 5.61502 19.0899 5.61502 18.6999 6.00502L8.79992 15.905Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.30c8825e42de3762ce3b2d9ea02cbc70.svg";
export { ForwardRef as ReactComponent };